/**公共引用 */
import React from 'react';
import $ from 'jquery';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import { Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog } from 'element-react';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, messageShow, isNotNull, systemConfig, getZkShopName, getTaoteShopName } from '../../utils/http';
import ShowModal from '../../components/showModal/index.jsx';
import { SupplierMarkeListRequest, SaveSupplierMarkeRequest,SaveOrderConfigRequest,GetOrderConfigRequest } from '../../utils/api';
import PlatformName from '../../components/platformName/index.jsx';
import NewUserGuide from '../../components/newUserGuide/index.jsx';

/**其他引用 */
import './supplierMarke.less'

class supplierMarke extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            loadingTitle: "加载中...",
            supplierMarkeList: [],//供应商标记列表

            selectedSupplier: [],//当前选中的供应商
            markeSupplierDailog: false,//标记供应商对话框
            markeCancelDailog: false,//取消标记对话框
            markeConfirmDailog: false,//确认标记对话框
            supportSupplierMarkeCancelDailog: false,//支持密文下单的供应商取消对话框

            pagesize: 10,//分页 
            totals: 0,
            current: 1,

            /* 供应商标记dto */
            supplierMarkeDto: {
                IsSupport: "",
                SupplierLoginId: "",
                MarkeType: "EncryCreateOrder",
                PlatformType:getLoginShopInfo().loginShopPlatformType,
            },
            searchSelectPatform: [
                { Id: 1, Title: '抖音', Icon: 'TouTiao', isActive: true },
                { Id: 2, Title: '快手', Icon: 'KuaiShou', isActive: false }
            ],

            //===================下单配置=============================
            orderConfig:{

            },
            AutoEncryptCreateOrder:[],//自动密文下单
            CustomeEncryptCreateOrder:[],//自定义供应商密文下单
            AllEncryptCreateOrder:[],//全部密文下单
            showSupplierList:false,//供应商列表
            allEncryptCreateOrderConfirmDailog:false,//设置全部密文下单对话框
        };
    }
    componentDidMount() {
        setTimeout(() => {
            this.loadSupplierMarke();
            this.loadOrderConfig();
        }, 1500)
    }
    searchSupplierMarke(){
        this.state.current = 1
        this.loadSupplierMarke();
    }
    //加载供应商标记列表
    async loadSupplierMarke(){
        this.setState({ isLoading:true})
        var data = this.state.supplierMarkeDto;
        data.PageIndex = this.state.current;
        data.PageSize = this.state.pagesize;
        data.PlatformType = getLoginShopInfo().loginShopPlatformType;
        const res = await SupplierMarkeListRequest(data)
        this.state.isLoading = false;
        if(res.Success)
        {
            this.state.supplierMarkeList = res.Data.List || [];
            this.state.totals = res.Data.TotalCount;
        }
        this.setState({})
    }
    /**标记/取消供应商对话框 */
    saveSupplierMarkeDailog(value, ...suppliers) {
        if (value == "1") {
            this.state.markeSupplierDailog = true;
            this.state.selectedSupplier = suppliers;
        }
        else {
            this.state.selectedSupplier = suppliers;
            if(suppliers[0].Remark && suppliers[0].Remark.includes('系统自动'))
            {
                this.state.supportSupplierMarkeCancelDailog = true;
            }else{
                this.state.markeCancelDailog = true;
            }
        }
        this.setState({});
    }
    /**确认标记供应商密文下单对话框 */
    saveSupplierMarkeConfirmDailog() {
        this.state.markeConfirmDailog = true;
        this.setState({});
    }
    /**联系供应商 */
    contactSupplier(wangwang) {
        if (wangwang) {
            window.open("https://amos.alicdn.com/getcid.aw?charset=utf-8&uid=" + wangwang + "&site=cnalichn")
        }
        else if (this.state.selectedSupplier && this.state.selectedSupplier.length > 0) {
            window.open("https://amos.alicdn.com/getcid.aw?charset=utf-8&uid=" + this.state.selectedSupplier[0].SupplierLoginId + "&site=cnalichn")
            this.closeMarkeSupplierDailog()
        }
    }
    /**关闭标记对话框 */
    closeMarkeSupplierDailog() {
        this.state.markeCancelDailog = false;
        this.state.supportSupplierMarkeCancelDailog = false;
        this.state.markeSupplierDailog = false;
        this.state.markeConfirmDailog = false;
        this.state.selectedSupplier = [];
        this.setState({});
    }
    /**保存标记供应商请求 */
    saveSupplierMarke(value, suppliers) {
        if (!suppliers || suppliers.length == 0) {
            if (!this.state.selectedSupplier || this.state.selectedSupplier.length == 0) {
                messageShow("请选择供应商", 'info');
                return;
            }
            suppliers = this.state.selectedSupplier;
        }
        const data = {
            MarkeType: "EncryCreateOrder",
            MarkeValue: value,
            SupplierList: suppliers,
            PlatformType: getLoginShopInfo().loginShopPlatformType
        }
        const that = this;
        SaveSupplierMarkeRequest(data).then(res => {
            if (res.Success) {
                if (value == "1")
                    messageShow('标记成功', 'info')
                else
                    messageShow('取消标记成功', 'info')
                setTimeout(() => { that.loadSupplierMarke(); }, 1500)
            }
            else
                messageShow(res.Message, 'error')
        })
        this.closeMarkeSupplierDailog();
    }

    //更新视图
    changeSupport(value) {
        this.state.supplierMarkeDto.IsSupport = value;
        this.state.current = 1;
        this.setState({});
    }
    changeSupplierLoginId(value) {
        this.state.supplierMarkeDto.SupplierLoginId = value;
        this.setState({});
    }
    //改变页码
    changePageCurrent(current) {
        this.setState({ current: current }, () => {
            this.loadSupplierMarke()
        })

    }
    to(path, obj) {
        var path = {
            pathname: path,
            state: obj
        }
        this.props.location.history.push(path);
    }
    //改变 一页多少条
    changePageSize(pagesize) {
        this.setState({ pagesize: pagesize, current: 1 }, () => {
            this.loadSupplierMarke()
        })
    }
    cancelModul = (typeName) => {
        this.setState({
            [typeName]: false
        })
    }
    changeNav = (name) => {
        this.props.history.replace(name)
    }
    changePatform = (id) => {
        let searchSelectPatform = this.state.searchSelectPatform;
        searchSelectPatform.forEach((item) => {
            item.isActive = false;
            if (item.Id == id) {
                item.isActive = true;
            }
        })
        this.setState({ searchSelectPatform })
    }

    async loadOrderConfig()
    {
        const res = await GetOrderConfigRequest();
        if(res.Success){
            if(res.Data){
                if(res.Data.AllEncryptCreateOrder){
                    this.state.AllEncryptCreateOrder = res.Data.AllEncryptCreateOrder.split(',')
                }
                if(res.Data.CustomeEncryptCreateOrder){
                    this.state.CustomeEncryptCreateOrder = res.Data.CustomeEncryptCreateOrder.split(',')
                }
                if(res.Data.AutoEncryptCreateOrder){
                    this.state.AutoEncryptCreateOrder = res.Data.AutoEncryptCreateOrder.split(',')
                }
            }
            let pts = [this.state.supplierMarkeDto.PlatformType];
            for(const platformtype of pts){
                if(!this.state.CustomeEncryptCreateOrder.includes(platformtype) 
                && !this.state.AllEncryptCreateOrder.includes(platformtype) 
                && !this.state.AutoEncryptCreateOrder.includes(platformtype))
                {
                    this.state.AutoEncryptCreateOrder.push(platformtype);
                }
            }
            setTimeout(()=>{
                this.showSupplierMarkList()
                this.setState({ orderConfig:res.Data});
            },100)
        }
    }
    async saveOrderConfig(isAutoEncryptMark){
        if(!isAutoEncryptMark){
            isAutoEncryptMark = $("input[name=ciphertextOrderSet]:checked").val()
        }
        let data = { 
            EncryptCreateOrder: isAutoEncryptMark,
            AllEncryptCreateOrder:this.state.AllEncryptCreateOrder.join(','),
            AutoEncryptCreateOrder:this.state.AutoEncryptCreateOrder.join(','),
            CustomeEncryptCreateOrder:this.state.CustomeEncryptCreateOrder.join(','),
        }
        this.setState({ isLoading : true })
        const res = await SaveOrderConfigRequest(data);
        this.setState({ isLoading : false })
        messageShow('保存成功')
        setTimeout(()=>{
            this.loadSupplierMarke();
            this.loadOrderConfig();
        },800)
        
    }
    showSupplierMarkList(){
        if(this.state.AllEncryptCreateOrder.includes(this.state.supplierMarkeDto.PlatformType))
            this.state.showSupplierList = false
        else
            this.state.showSupplierList = true
    }
    encryptCreateOrderChange(encryptCreateOrder,confirm){
        if(!this.state.supplierMarkeDto.PlatformType)
            return;

        if(encryptCreateOrder == "All" && !confirm && confirm != false){
            this.setState({ allEncryptCreateOrderConfirmDailog: true})
            return;
        }
        
         //删除平台
         this.state.AllEncryptCreateOrder = this.state.AllEncryptCreateOrder.filter(x => x != this.state.supplierMarkeDto.PlatformType)
         this.state.AutoEncryptCreateOrder = this.state.AutoEncryptCreateOrder.filter(x => x != this.state.supplierMarkeDto.PlatformType)
         this.state.CustomeEncryptCreateOrder = this.state.CustomeEncryptCreateOrder.filter(x => x != this.state.supplierMarkeDto.PlatformType)
 
         if(encryptCreateOrder == 'All')
             this.state.AllEncryptCreateOrder.push(this.state.supplierMarkeDto.PlatformType)
         else if(encryptCreateOrder == 'Auto')
             this.state.AutoEncryptCreateOrder.push(this.state.supplierMarkeDto.PlatformType)
         else if(encryptCreateOrder == 'Custom')
             this.state.CustomeEncryptCreateOrder.push(this.state.supplierMarkeDto.PlatformType)
 
         this.state.allEncryptCreateOrderConfirmDailog = false
         this.showSupplierMarkList()
        this.setState({ })
    }
    render() {
        return (

            <div className='wrap'>
                <HeaderMenu />
                <main>
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeNav} defaultActive={"/supplierMarke"} />
                    </div>
                    <div className="wrap-right">

                        <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav}
                            from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' : null}
                            alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()} />


                        <div className="supplierMarkeWrap wrap">
                            {/* <div className="zk-maiwrap mainColor" style={{ marginBottom: '15px', padding: "10px 15px", fontSize: "12px", backgroundColor: "#fefce8", border: "1px solid #ffdda4", boxShadow: "unset" }}>
                                <i className="iconfont icon-gantan" style={{ color: "#f7941f", fontSize: "16px", marginRight: "5px" }}></i>
                                <span className='dangerColor'>此页面只针对抖音、快手平台店铺使用，淘宝店铺自动使用密文下单，其他平台店铺请勿操作。</span>
                            </div> */}
                            <div className='zk-maiwrap '>
                                <div>
                                    <span style={{fontSize:'20px'}}>密文下单设置</span>
                                    <i style={{ color: "#888", marginLeft: '5px', fontSize: '12px' }}> 优势:不消耗店铺解密额度，无需解密，不限量采购下单。</i>
                                    <a className='dColor' href='https://docs.qq.com/doc/DYkFjV3R2TFZKUnZn' target='_blank'>点此了解详情</a>
                                </div>
                            </div>

                            <div className="zk-maiwrap" style={{ marginBottom: '15px' }}>
                                {/* <div style={{ width: '100%' }}>
                                    <div className='suppierMarke-title'><span>密文下单设置<i style={{ color: "#888", marginLeft: '5px', fontSize: '12px' }}>优势:不消耗店铺解密额度，无需解密，不限量采购下单。</i><a className='dColor' href='https://docs.qq.com/doc/DYkFjV3R2TFZKUnZn?spm=a26370.isv_inner_8076003.0.0.2c43ftq3ftq37W' target='_blank'>点此了解详情</a></span></div>
                                </div> */}
                                
                                <div className='order-config-maiwrap'>
                                    <div>
                                        <div className='ciphertextOrderSet'>
                                            <label> 
                                                <input type="radio" name="ciphertextOrderSet"  value='Auto' onChange={(e)=>{ this.encryptCreateOrderChange(e.target.value)}} 
                                                checked={this.state.AutoEncryptCreateOrder.includes(this.state.supplierMarkeDto.PlatformType)}/> 
                                                <span> 自动密文下单</span>
                                                <i className='commonWenHao popoverCommon'>?<div className='popoverCommon-warn' style={{ width: '380px', maxWidth:'380px',bottom: '22px', lineHeight: '25px', color: '#333' }}>
                                                    {/* <div>1.铺货或关联了密文下单商品，系统会自动对供应商进行标记使用密文下单。</div>
                                                    <div>2.系统自动检测供应商情况，对已支持密文下单的供应商进行自动标记，对不支持密文下单的供应商进行自动取消标记。</div> */}
                                                    <div>
                                                        系统自动识别供应商是否支持密文下单，仅针对支持的供应商进行标记使用密文下单，其余使用解密下单。此模式下也可手动额外标记供应商。
                                                    </div>
                                                </div>
                                                </i>
                                            </label>
                                            <label> 
                                                <input type="radio" name="ciphertextOrderSet"  value='Custom' onChange={(e)=>{ this.encryptCreateOrderChange(e.target.value)}} 
                                                    checked={this.state.CustomeEncryptCreateOrder.includes(this.state.supplierMarkeDto.PlatformType)}/> 
                                                <span> 指定供应商密文下单</span>
                                                <i className='commonWenHao popoverCommon'>?<div className='popoverCommon-warn' style={{ width: '380px', maxWidth:'380px',bottom: '22px', lineHeight: '25px', color: '#333' }}>
                                                    <div>
                                                        仅对标记的的供应商使用密文下单，其他供应商使用解密下单。请对如下供应商进行标记
                                                    </div>
                                                </div>
                                                </i>
                                            </label>
                                            <label> 
                                                <input type="radio" name="ciphertextOrderSet"  value='All' onChange={(e)=>{ this.encryptCreateOrderChange(e.target.value)}} 
                                                    checked={this.state.AllEncryptCreateOrder.includes(this.state.supplierMarkeDto.PlatformType)}/> 
                                                <span> 全部密文下单</span>
                                                <i className='commonWenHao popoverCommon'>?<div className='popoverCommon-warn' style={{ width: '380px', maxWidth:'380px',bottom: '22px', lineHeight: '25px', color: '#333' }}>
                                                    <div>
                                                    不管供应商是否支持，所有订单都使用密文下单
                                                    </div>
                                                </div>
                                                </i>
                                            </label>
                                        </div>
                                        <div style={{paddingBottom:'20px',paddingTop:'10px',width:'100%'}}>
                                            <label style={{marginLeft:"20px",color:'#ff2424'}}>注:无论自动还是手动模式，只要对供应商标记密文下单后，对该供应商下单就会使用密文下单，不消耗店铺解密额度</label>
                                        </div>
                                        <div style={{width:'100%'}}>
                                        {/* <Button onClick={(()=>{ this.saveOrderConfig('0')})}>取消</Button> */}
                                        <Button type="primary" onClick={()=>{ this.saveOrderConfig() }}>保存</Button>
                                        </div>
                                    </div>
                                    <div className='encrypt-risk-inform'>
                                        <div className='encrypt-risk-inform-title' style={{fontSize:'17px'}}>密文下单说明：</div>
                                        <div style={{fontSize:'12px'}}>
                                            密文下单功能只针对1688货源平台供应商，开通密文下单后，<span style={{color:'rgb(255, 36, 36)'}}>可能存在因下游平台个人信息保护要求导致1688供应商无法获得必要发货信息</span>，影响您的订单发货及时性，您需关注旺旺消息或主动联系供应商配合提供必要收货信息方可正常发货
                                        </div>
                                    </div>
                                </div>
                                
                                
                            </div>

                            {/* 输入框 搜索 */}
                            {
                                this.state.showSupplierList ? 
                                <div>
                                    <div className='zk-maiwrap' style={{ paddingBottom: 0 }}>
                                        <div className='suppierMarke-title'>
                                            <span>供应商支持密文情况
                                                {
                                                    this.state.orderConfig.LastSyncTime  ?
                                                    <i style={{ marginLeft:'20px',fontSize:'12px',color: '#feab30'}}>上次同步时间：{this.state.orderConfig.LastSyncTime}</i> 
                                                    : null
                                                }
                                            </span>
                                        </div>

                                        {/* <div className='myTabsPane'>
                                            {
                                                this.state.searchSelectPatform.map((item) =>
                                                    <div onClick={() => this.changePatform(item.Id)} className={item.isActive ? "myTabsPane-item active" : "myTabsPane-item"}>{item.Title}</div>
                                                )
                                            }


                                        </div> */}

                                        <div className='zk-search'>
                                            <div className='zk-search-wrap'>
                                                <label>
                                                    <select id="selectDaysId">
                                                        <option value="" selected>全部供应商</option>
                                                    </select>
                                                </label>

                                                <label>
                                                    <select id="isSupport" onChange={(e) => { this.changeSupport(e.target.value) }} >
                                                        <option value="">是否支持密文下单</option>
                                                        <option value="1">是</option>
                                                        <option value="0">否</option>
                                                    </select>
                                                </label>
                                                <label>
                                                    <input type="text" id="supplierLoginId" placeholder="供应商旺旺" onChange={(e) => { this.changeSupplierLoginId(e.target.value) }} />
                                                </label>
                                            </div>
                                            <span class="el-button el-button--primary" onClick={() => this.searchSupplierMarke(true)}>查询</span>
                                        </div>
                                    </div>
                                    {/* 输入框 搜索     ----end*/}


                                    {/* 表格*/}
                                    <div className="zk-maiwrap">
                                        <table className="table-style01 logTableWith" id="orderList_table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "180px" }}>1688供应商</th>
                                                    {/* <th style={{ width: "150px" }}>代销商品数量</th> */}
                                                    <th style={{ width: "150px" }}>标记时间</th>
                                                    <th style={{ width: "150px" }}>是否支持密文下单</th>
                                                    <th style={{ width: "180px" }}>操作</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* 无数据*/}
                                                {
                                                    this.state.supplierMarkeList.length == 0 ?
                                                        <tr>
                                                            <td className="noneData" colSpan="20">
                                                                <div className="noneData-wrap">
                                                                    <i className="iconfont icon-wushuju"></i>
                                                                    <span className="noneData-title">暂无数据！</span>
                                                                </div>
                                                            </td>
                                                        </tr> : null
                                                }

                                                {/* */}
                                                {
                                                    this.state.supplierMarkeList.length > 0 ?
                                                        this.state.supplierMarkeList.map(ele => {
                                                            return <tr>
                                                                <td >
                                                                    <div class="productShow table-product">
                                                                        <ul>
                                                                            <li className="gysWrap">
                                                                                <span class="mainColor">{ele.SupplierLoginId ? ele.SupplierLoginId : ""}</span>
                                                                                <a className="iconfont icon-wangwang" onClick={() => { this.contactSupplier(ele.SupplierLoginId) }}></a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                                {/* <td><a href='javascript:void(0)' onClick={()=>{ this.to("proxyProduct",{ supplierLoginId:ele.SupplierLoginId}) }}>{ ele.DistributionCnt }</a></td> */}
                                                                <td>{ele.UpdateTime ? ele.UpdateTime : "--"}</td>
                                                                <td>
                                                                    {ele.MarkeValue ? ele.MarkeValue == "1" ? <span><i class="dot-ZT" style={{ backgroundColor: "#5584ff" }} ></i>已支持</span> : <span><i class="dot-ZT" style={{ backgroundColor: "rgb(247, 148, 31)" }}></i>已取消</span> : "--"}
                                                                    {
                                                                        ele.Remark ? '(' + ele.Remark + ')' : null
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        ele.MarkeValue == "1" ?
                                                                            <a href='javascript:void(0)' onClick={() => { this.saveSupplierMarkeDailog("0", ele) }} style={{ marginRight: "15px", "color": "rgb(247, 148, 31)" }}>取消密文下单 </a> :
                                                                            <a className='dColor' href='javascript:void(0)' onClick={() => { this.saveSupplierMarkeDailog("1", ele) }} style={{ marginRight: "15px" }}>标记密文下单 </a>
                                                                    }
                                                                    <a className='dColor' href='javascript:void(0)' onClick={() => { this.contactSupplier(ele.SupplierLoginId) }}>联系供应商</a>
                                                                </td>
                                                            </tr>
                                                        }) : null
                                                }

                                            </tbody>
                                        </table>

                                        {/* <Paginations current={this.state.current} totals={this.state.totals} pageSize={this.state.pagesize} changePageSize={(pagesize) => { this.changePageSize(pagesize) }} changePageCurrent={(current) => this.changePageCurrent(current)} /> */}
                                    </div>
                                    <div className='paginationwrap zk-maiwrap'>
                                        <Pagination onCurrentChange={this.changePageCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.totals} pageSize={this.state.pagesize} currentPage={this.state.current} pageSizes={[10, 30, 50]} />
                                    </div>
                                    {/* 表格   ----end*/}
                                </div>:null
                            }
                            { /** */}
                            <ShowModal titleName={"请确认标记供应商"} width={"600px"} showModal={this.state.markeSupplierDailog} hideBtn={true} cancelDailog={() => this.cancelModul("markeSupplierDailog")} showRightTopBtn={true} showTitleClose={true}>
                                <div className='markeSupplierDailog'>
                                    <div className='showTips'>
                                        <span className='showTips-title' style={{ color: "#f88600", fontSize: "13px" }}>请提前与供应商沟通协商，确认供应商使用的软件支持打印分销密文订单，否则会造成供应商不能打印发货此类订单而产生纠纷</span>
                                    </div>
                                    <div className='markeSupplierDailog-title'>
                                        <div className='markeSupplierDailog-title-main' style={{ marginTop: "20px" }}>
                                            标记成功后，对此供应商商品下采购单时，将使用密文进行下单，不消耗店铺解密额度
                                        </div>
                                        <div className='markeSupplierDailog-title-imgwrap'>
                                            <img src="https://www.dgjapp.com/public/upload/2022-12-05-dgj-log.png" alt="" />
                                            <div className='markeSupplierDailog-imgwrap-title'>
                                                <span style={{ paddingLeft: "5px" }}>建议供应商使用【店管家_批量打印发货】</span>
                                                <span>
                                                    <a className='defColor' target="_blank" href='https://pc.1688.com/product/detail.htm?spm=a260s.11177607.jcrmedqi.1.2a8a646bDKBjSJ&productCode=BwGsFBURIR0cYkhvcI5yifNnSBVD4aodNPM0sr8CkWY%3D&productType=GROUP&keywords=%E5%BA%97%E7%AE%A1%E5%AE%B6'>
                                                        【店管家_批量打印发货】
                                                    </a>
                                                    已支持打印此类订单
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="showModalWrap-box-commonfooter">
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn" onClick={() => { this.saveSupplierMarkeConfirmDailog() }}>确认标记</span>
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.contactSupplier() }}>联系供应商</span>
                                    </div>
                                </div>
                            </ShowModal>

                            <ShowModal titleName={"温馨提示"} width={"400px"} cancelDailog={() => { this.closeMarkeSupplierDailog() }} showModal={this.state.markeConfirmDailog} hideBtn={true} showTitleClose={true}>
                                <div>
                                    <div style={{ fontSize: "14px" }}>
                                        确认已与供应商协商，并标记使用密文下单！
                                    </div>
                                    <div className="showModalWrap-box-commonfooter" style={{ "marginTop": "30px" }}>
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn" onClick={() => { this.saveSupplierMarke("1") }}>确认标记</span>
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.closeMarkeSupplierDailog() }}>取消</span>
                                    </div>
                                </div>
                            </ShowModal>

                            <ShowModal titleName={"确认取消"} width={"500px"} showModal={this.state.markeCancelDailog} hideBtn={true} showTitleClose={true} cancelDailog={() => { this.closeMarkeSupplierDailog() }}>
                                <div>
                                    <div style={{ fontSize: "14px" }}>
                                        取消标记后，对此供应商品下采购单时，需要解密订单进行下单，会消耗店铺解密额度
                                    </div>
                                    <div className="showModalWrap-box-commonfooter">
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn" onClick={() => { this.saveSupplierMarke("0") }}>取消标记</span>
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.closeMarkeSupplierDailog() }}>取消</span>
                                    </div>
                                </div>
                            </ShowModal>

                            <ShowModal titleName={"确认"} width={"500px"} showModal={this.state.supportSupplierMarkeCancelDailog} hideBtn={true} showTitleClose={true} cancelDailog={() => { this.closeMarkeSupplierDailog() }}>
                                <div  style={{ fontSize: "14px" }}>
                                    <div>
                                        系统检测到当前1688供应商支持密文下单，确认是否取消标记?
                                    </div>
                                    <div style={{ marginTop:"10px"}}>
                                        取消标记后，对此供应商品下采购单时，需要解密订单进行下单会消耗店铺解密额度
                                    </div>
                                    <div className="showModalWrap-box-commonfooter">
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn" onClick={() => { this.saveSupplierMarke("0") }}>取消标记</span>
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.closeMarkeSupplierDailog() }}>取消</span>
                                    </div>
                                </div>
                            </ShowModal>
                            <ShowModal titleName={"确认是否全部密文下单"} width={"500px"} showModal={this.state.allEncryptCreateOrderConfirmDailog} hideBtn={true}>
                                <div>
                                    <div style={{padding:'20px'}}>
                                        <div style={{fontSize:"14px"}}>
                                            1. 开启后，所有订单将使用<span style={{color:'rgb(254, 173, 51)'}}>密文方式下单</span>，<span style={{color:'rgb(254, 173, 51)'}}>不消耗店铺解密额度</span>，供应商无法看到买家详细收件地址。
                                        </div>
                                        <div style={{fontSize:"14px",marginTop:"20px"}}>
                                            2. 请务必与供应商沟通协商，<span style={{color:'rgb(254, 173, 51)'}}>确认供应商使用的软件支持打印分销密文订单</span>,否则会造成供应商不能打印发货此类订单而产生纠纷。如供应商当前不支持可推荐供应商使用【
                                            <a target="_blank" className='defColor hover' href='https://pc.1688.com/product/detail.htm?spm=a260s.11177607.jcrmedqi.1.2a8a646bDKBjSJ&productCode=BwGsFBURIR0cYkhvcI5yifNnSBVD4aodNPM0sr8CkWY%3D&productType=GROUP&keywords=%E5%BA%97%E7%AE%A1%E5%AE%B6'>
                                            店管家_批量打印发货</a>】 进行打单
                                        </div>
                                    </div>
                                    
                                    <div className="showModalWrap-box-commonfooter">
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn" onClick={() => { this.encryptCreateOrderChange("All",true)}}>确定选择</span>
                                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn cancleBtn" onClick={ ()=>{ this.cancelModul('allEncryptCreateOrderConfirmDailog') }}>取消</span>
                                    </div>
                                </div>
                            </ShowModal>
                            {/* <Loading isLoading={this.state.isLoading} hasBorder={true} isShade={false} isStopOperate={true} title={this.state.loadingTitle} /> */}
                        </div>
                    </div>
                </main>
                <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} title={this.state.loadingTitle} />
                <NewUserGuide></NewUserGuide>
            </div>

        );
    }
}

export default supplierMarke;



// WEBPACK FOOTER //
// ./src/pages/supplierMarke/supplierMarke.jsx